// extracted by mini-css-extract-plugin
export var explainable = "_ij-a";
export var printerCard = "_ij-1";
export var printerCardConfigured = "_ij-2";
export var printerCardError = "_ij-3";
export var printerCardsContainer = "_ij-0";
export var printerIcon = "_ij-8";
export var printerIconConfigured = "_ij-5";
export var printerIconContainer = "_ij-4";
export var printerIconError = "_ij-6";
export var printerIconUnconfigured = "_ij-7";
export var workstationsTableCard = "_ij-9";